export default "__VITE_ASSET__f824c39b__"